{
  "format": {
    "group": {
      "description": "Вы будете на экскурсии в группе с другими участниками",
      "label": "Групповой",
      "plural": "Групповые"
    },
    "individual": {
      "description": "Личная встреча с гидом только для вас и вашей компании",
      "label": "Индивидуальный",
      "plural": "Индивидуальные"
    },
    "minigroup": {
      "description": "Групповой формат до 10 человек",
      "label": "Мини-группа",
      "plural": "Мини-группы"
    },

    "groupTour": {
      "description": "С другими участниками",
      "label": "Групповой",
      "plural": "Групповые"
    },
    "individualTour": {
      "description": "Только для вас и вашей компании",
      "label": "Индивидуальный",
      "plural": "Индивидуальные"
    },
    "minigroupTour": {
      "description": "До 10 человек в группе",
      "label": "Мини-группа",
      "plural": "Мини-группы"
    },
    "title": "Формат проведения"
  }
}
